<template>    
    <component v-bind:is="stepComponent" v-model="propsPage" @emitirDados="(obj) => emitir(obj)"></component>
</template>

<script>
export default {
    name: "SGPDynamicImportComponent",    
    props: {
        pathFile: {
            type: String,
            required: true
        },
        propsPage : {
            type: Object,
            required: true
        }
    },
    computed: {
        stepComponent() {    
            return () => import(`@/${this.pathFile}.vue`);            
        }
    },

    methods: {
        emitir(obj) {
            this.$emit(obj.emitName, obj.value)
        }
    }
}
</script>